
<div class="top-header">
    <div class="right-menu">
  
      <div class="top-btn homeIcon" *ngIf="this.login_user_details.userinfo.user_type === 'is_customer'" matTooltip="Cart" matBadge={{cart_Count}} style="margin-right: 16px;" matBadgeOverlap="true">
        <i class="fa fa-shopping-cart" aria-hidden="true"></i>
      </div>
  
  
      <div class="top-btn homeIcon" matTooltip="Back to Home Page" (click)="backtoHome()">
        <i class="fa fa-home" aria-hidden="true"></i>
      </div>
  
  
      <div class="top-btn usericon">
        <i class="fa fa-user-circle-o" aria-hidden="true"></i>
      </div>
  
  
  
      <h3><span *ngIf="textLoader"></span> {{ userName }}</h3>
  
  
      <div class="top-btn" [matMenuTriggerFor]="rightdownmenu">
        <i class="fa fa-angle-down" aria-hidden="true"></i>
      </div>
  
      <mat-menu #rightdownmenu="matMenu">
  
        <button mat-menu-item (click)="myAccount()">
          <i class="fa fa-user-circle-o" aria-hidden="true"></i> My Account
        </button>
  
        <button mat-menu-item (click)="changePass()">
          <i class="fa fa-unlock-alt" aria-hidden="true"></i> Change Password
        </button>
  
        <button *ngIf="(cookieData.userinfo.user_type === 'is_astrologer' ||cookieData.userinfo.user_type === 'is_tarotreader') && cookieData.userinfo?.unique_name" mat-menu-item (click)="navigateToPath('profile/' + cookieData.userinfo?.unique_name)">
          <i class="fa fa-user" aria-hidden="true"></i> View Profile
        </button>
  
  
        <button *ngIf="cookieData.userinfo.user_type ==='is_astrologer' || cookieData.userinfo.user_type === 'is_tarotreader'" mat-menu-item (click)="navigateToPath('astrologer-dashboard/profile/edit/' + cookieData.userinfo._id)">
          <i class="fa fas fa-edit" aria-hidden="true"></i> {{cookieData.userinfo?.unique_name?"Edit" : "Setup"}} Profile
        </button>
  
  
        <button mat-menu-item (click)="logout()">
          <i class="fa fa-sign-out" aria-hidden="true"></i> Logout
        </button>
  
  
      </mat-menu>
  
  
  
    </div>
  </div>
  
  
  <div class="logo-wrapper">
    <div class="logo-sub-wrapper">
      <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" alt="" />
    </div>
  </div>
  
  
  <div class="header_mainwrapper">

    <div class="header_subwrapper">
      <div class="menu-wrapper" [class.showmenu]="classToggled">
        <ul>
  
  
          <!-- Dashboard Navigation -->
          <li routerLinkActive="active">
            <a [ngClass]=" currentPath() == '/diviner/dashboard' ? 'active': ''" (click)="navigateToPath('/diviner/dashboard')">Dashboard</a>
          </li>
          <li routerLinkActive="active">
            <a [ngClass]=" currentPath() == '/diviner/transactions' ? 'active': ''" (click)="navigateToPath('/diviner/transactions')">Transactions</a>
          </li>
  
        </ul>
      </div>
      <div (click)="toggleNav()" class="toggleBtn">
        <i class="fa fa-bars" aria-hidden="true"></i>
      </div>
    </div>
  </div>